module.exports = __webpack_public_path__ + "img/semyonova.f95f1268.jpg";